import { msg } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { titleFor } from '~/lib/route-title'

// Pass-through layout so /files and /files/trash mount as sibling pages
// instead of /files/trash trying to nest inside the workspace files view.
const FilesLayout = () => <Outlet />

export const Route = createFileRoute('/_authenticated/$workspaceSlug/files')({
  component: FilesLayout,
  head: () => ({ meta: [{ title: titleFor(msg`Files`) }] }),
})
